// import React, { useState, useEffect } from "react";
// import { Button, Menu, MenuItem } from "@mui/material";
// import useStore from "../store/store";
// import { Link, NavLink } from "react-router-dom";
// import ProrationCalculator from "./prorationCalculator";
// import image from "../images/menu.png";
// import Box from "@mui/material/Box";
// import Drawer from "@mui/material/Drawer";
// import List from "@mui/material/List";
// import Divider from "@mui/material/Divider";
// import ListItem from "@mui/material/ListItem";
// import ListItemText from "@mui/material/ListItemText";
// import Popover from "@mui/material/Popover";
// import CircularProgress from "@mui/material/CircularProgress";
// import Modal from "@mui/material/Modal";
// import axios from "axios";
// import { useCookies } from "react-cookie";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../context/AuthProvider";
// import useAxiosInstance from "../helpers/useAxiosInstance";

// const Navbar = () => {
//   const [cookies, setCookie, removeCookie] = useCookies();
//    const navigate = useNavigate();
//    const {clearContext} = useAuth()
//   const setUser = useStore((state) => state.setUser);

//    const axiosInstance = useAxiosInstance()

//   const handleLogout = () => {


//      Object.keys(cookies).forEach((cookieName) => {
//       removeCookie(cookieName);
//     });
//     clearContext()
//     navigate("/login");
// };

//   const [modalLoader, setModalLoader] = useState(false);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [isDrawerOpen, setIsDrawerOpen] = useState(false);
//   const handleClick = () => {
//     setIsDropdownOpen(true);
//   };

//   const handleClose = () => {
//     setIsDropdownOpen(false);
//   };
//   const handleDrawerOpen = () => {
//     setIsDrawerOpen(true);
//   };

//   const handleDrawerClose = () => {
//     setIsDrawerOpen(false);
//   };

//   const updateRating = async () => {
//     setModalLoader(true);
//     const response = await 
//       axiosInstance.get(process.env.REACT_APP_API_URL + "/getPlaceIdProperties")
//       .then(async (res) => {
//         console.log(res.data);
//         for (let item of res.data) {
//           const response = await axiosInstance
//             .get(
//               process.env.REACT_APP_API_URL + "/upload-google-rating/" + item.id
//             )
//             .then((res) => {})
//             .catch((error) => {
//               setModalLoader(false);
//               console.error("Error:", error.response.data);
//             });
//         }
//         setModalLoader(false);
//       })
//       .catch((error) => {
//         setModalLoader(false);
//         console.error("Error:", error.response.data);
//       });
//   };

//   return (
//     <div className="bg-[#1E2125] text-white py-4 px-6 2xl:px-10 flex justify-between items-center sticky top-0 z-10">
//       {/* Left Content: Logo + Mobile Menu Icon */}

//       <div className="flex items-center justify-between gap-14 2xl:gap-20">
//         <div className="flex items-center gap-4">
//           {/* Mobile Menu Icon - only on mobile */}
//           <div className="md:hidden mt-1" onClick={handleDrawerOpen}>
//             <img width={20} src={image} alt="Menu" />
//           </div>

//           {/* Logo */}
//           <div className="text-2xl font-bold">
//             <NavLink to="/" className="hover:text-gray-300">
//               Sidekick
//             </NavLink>
//           </div>
//         </div>

//         {/* Right Content: Nav Links (on md+) + Logout */}
//         <div className="flex items-center gap-8">
//           <nav className="hidden md:flex items-center gap-4 xl:gap-8">
//             {[
//               { to: "/search", label: "New Search" },
//               { to: "/searches", label: "Search History" },
//               { to: "/clients", label: "Clients" },
//               { to: "/conversations", label: "Conversations" },
//               { to: "/properties", label: "Properties" },
//               { to: "/commission", label: "Commission" },
//               { to: "/file-storage", label: "Drive" },
//             ].map(({ to, label }) => (
//               <NavLink
//                 key={to}
//                 to={to}
//                 className={({ isActive }) =>
//                   `px-2 ${isActive ? " font-bold" : "hover:opacity-75"}`
//                 }
//               >
//                 {label}
//               </NavLink>
//             ))}

//             {/* Proration Popover */}
//             <div
//               className="relative cursor-pointer hover:opacity-75 px-2"
//               onClick={handleClick}
//             >
//               Proration
//             </div>
//             <Popover
//               open={isDropdownOpen}
//               onClose={handleClose}
//               anchorOrigin={{ vertical: "top", horizontal: "center" }}
//               transformOrigin={{ vertical: "top", horizontal: "center" }}
//             >
//               <div className="p-4 bg-white text-black rounded-xl">
//                 <ProrationCalculator />
//               </div>
//             </Popover>

//             <div
//               onClick={updateRating}
//               className="cursor-pointer hover:opacity-75 px-2"
//             >
//               Update Google Rating
//             </div>
//           </nav>
//         </div>
//       </div>

//       {/* Logout Button */}
//       <button
//         onClick={handleLogout}
//         className="bg-sidekick-tertiary hover:bg-opacity-80 py-1 px-4 rounded text-white"
//       >
//         Logout
//       </button>

//       {/* Mobile Drawer */}
//       <Drawer anchor="left" open={isDrawerOpen} onClose={handleDrawerClose}>
//         <List className="bg-[#1E2125] text-white">
//           {[
//             { label: "New Search", to: "/search" },
//             { label: "Search History", to: "/searches" },
//             { label: "Clients", to: "/clients" },
//             { label: "Conversations", to: "/conversations"  },
//             { label: "Properties", to: "/properties" },
//             { label: "Commission", to: "/commission" },
//             { label: "Drive", to: "/file-storage" },
//           ].map((item) => (
//             <ListItem
//               key={item.to}
//               button
//               component={NavLink}
//               to={item.to}
//               onClick={handleDrawerClose}
//             >
//               <ListItemText primary={item.label} />
//             </ListItem>
//           ))}
//         </List>
//         <Divider />
//         <List className="bg-[#1E2125] text-white">
//           <ListItem>
//             <div className="p-4 bg-white text-black rounded-xl">
//               <ProrationCalculator />
//             </div>
//           </ListItem>
//         </List>
//       </Drawer>

//       {/* Modal Loader */}
//       <Modal open={modalLoader}>
//         <Box
//           sx={{
//             position: "fixed",
//             inset: 0,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             bgcolor: "rgba(0, 0, 0, 0.6)",
//           }}
//         >
//           <div className="flex flex-col items-center gap-4 text-white">
//             <CircularProgress />
//             <div>
//               Updating Google rating. Please wait and do not navigate away.
//             </div>
//           </div>
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default Navbar;

import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import ProrationCalculator from "./prorationCalculator";
import image from "../images/menu.png";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Popover from "@mui/material/Popover";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import { useCookies } from "react-cookie";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import useAxiosInstance from "../helpers/useAxiosInstance";
import useStore from "../store/store";
import { hasAdminPriviledge, hasPermission } from "../helpers/accessHelper";
import { PERMISSIONS } from "../constants/access.constant";

const Navbar = () => {
  const [cookies, , removeCookie] = useCookies();
  const navigate = useNavigate();
  const { clearContext, isHydrated } = useAuth();
  const user = useStore((state) => state.user);
  const axiosInstance = useAxiosInstance();
  const clearUser = useStore((state) => state.clearUser);
  const [modalLoader, setModalLoader] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  if (!isHydrated) {
    return null;
  }

  const handleLogout = async () => {
    try {
      await axiosInstance.post("/auth/logout", {}, { withCredentials: true });
    } catch (error) {
      console.error("Logout API failed:", error?.response?.data || error.message);
    } finally {
      Object.keys(cookies).forEach((cookieName) => {
        removeCookie(cookieName);
      });
      Cookies.remove("accessToken", { path: "/" });
      clearContext();
      clearUser()
      navigate("/login");
    }
  };

  const handleClick = () => {
    setIsDropdownOpen(true);
  };

  const handleClose = () => {
    setIsDropdownOpen(false);
  };

  const handleDrawerOpen = () => {
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const updateRating = async () => {
    try {
      setModalLoader(true);

      const res = await axiosInstance.get(
        process.env.REACT_APP_API_URL + "/getPlaceIdProperties"
      );

      for (const item of res.data) {
        await axiosInstance.get(
          process.env.REACT_APP_API_URL + "/upload-google-rating/" + item.id
        );
      }
    } catch (error) {
      console.error("Error:", error?.response?.data || error.message);
    } finally {
      setModalLoader(false);
    }
  };

  const navItems = [
    {
      to: "/search",
      label: "New Search",
      permission: PERMISSIONS.SEARCH_CREATE,
    },
    {
      to: "/searches",
      label: "Search History",
      permission: PERMISSIONS.SEARCH_VIEW,
    },
    {
      to: "/clients",
      label: "Clients",
      permission: PERMISSIONS.CLIENT_VIEW,
    },
    {
      to: "/conversations",
      label: "Conversations",
      permission: PERMISSIONS.THREAD_VIEW,
    },
    {
      to: "/properties",
      label: "Properties",
      permission: PERMISSIONS.PROPERTY_VIEW,
    },
    {
      to: "/commission",
      label: "Commission",
      permission: PERMISSIONS.COMMISSION_VIEW,
    },
    {
      to: "/file-storage",
      label: "Drive",
      permission: PERMISSIONS.DRIVE_VIEW,
    },
  ];

  const visibleNavItems = navItems.filter((item) =>
    hasPermission(user, item.permission)
  );

  const canViewProperties = hasPermission(user, PERMISSIONS.PROPERTY_VIEW);
  const canEditProperties = hasPermission(user, PERMISSIONS.PROPERTY_EDIT);
  const isAdmin = hasAdminPriviledge(user)

  return (
    <div className="bg-[#1E2125] text-white py-4 px-6 2xl:px-10 flex justify-between items-center sticky top-0 z-10">
      {/* Left Content: Logo + Mobile Menu Icon */}

      <div className="flex items-center justify-between gap-14 2xl:gap-20">
        <div className="flex items-center gap-4">
          {/* Mobile Menu Icon - only on mobile */}
          <div className="md:hidden mt-1" onClick={handleDrawerOpen}>
            <img width={20} src={image} alt="Menu" />
          </div>

          {/* Logo */}
          <div className="text-2xl font-bold">
            <NavLink to="/" className="hover:text-gray-300">
              Sidekick
            </NavLink>
          </div>
        </div>

        {/* Right Content: Nav Links (on md+) + Logout */}
        <div className="flex items-center gap-8">
          <nav className="hidden md:flex items-center gap-4 xl:gap-8">
            {visibleNavItems.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `px-2 ${isActive ? " font-bold" : "hover:opacity-75"}`
                }
              >
                {label}
              </NavLink>
            ))}

            {/* Proration Popover */}
            {canViewProperties && (
              <>
                <div
                  className="relative cursor-pointer hover:opacity-75 px-2"
                  onClick={handleClick}
                >
                  Proration
                </div>

                <Popover
                  open={isDropdownOpen}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  transformOrigin={{ vertical: "top", horizontal: "center" }}
                >
                  <div className="p-4 bg-white text-black rounded-xl">
                    <ProrationCalculator />
                  </div>
                </Popover>
              </>
            )}

            {canEditProperties && isAdmin && (
              <div
                onClick={updateRating}
                className="cursor-pointer hover:opacity-75 px-2"
              >
                Update Google Rating
              </div>
            )}
          </nav>
        </div>
      </div>

      {/* Logout Button */}
      <button
        onClick={handleLogout}
        className="bg-sidekick-tertiary hover:bg-opacity-80 py-1 px-4 rounded text-white"
      >
        Logout
      </button>

      {/* Mobile Drawer */}
      <Drawer anchor="left" open={isDrawerOpen} onClose={handleDrawerClose}>
        <List className="bg-[#1E2125] text-white min-w-[250px]">
          {visibleNavItems.map((item) => (
            <ListItem
              key={item.to}
              button
              component={NavLink}
              to={item.to}
              onClick={handleDrawerClose}
            >
              <ListItemText primary={item.label} />
            </ListItem>
          ))}
        </List>

        <Divider />

        {canViewProperties && (
          <List className="bg-[#1E2125] text-white">
            <ListItem>
              <div className="p-4 bg-white text-black rounded-xl">
                <ProrationCalculator />
              </div>
            </ListItem>
          </List>
        )}
      </Drawer>

      {/* Modal Loader */}
      <Modal open={modalLoader}>
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "rgba(0, 0, 0, 0.6)",
          }}
        >
          <div className="flex flex-col items-center gap-4 text-white">
            <CircularProgress />
            <div>
              Updating Google rating. Please wait and do not navigate away.
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default Navbar;
